module.exports = __webpack_public_path__ + "fonts/iconfont.788e20d0.ttf";